import { render, staticRenderFns } from "./ConventionTeaserAction.vue?vue&type=template&id=5e2933b5"
import script from "./ConventionTeaserAction.vue?vue&type=script&lang=js"
export * from "./ConventionTeaserAction.vue?vue&type=script&lang=js"
import style0 from "./ConventionTeaserAction.vue?vue&type=style&index=0&id=5e2933b5&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports